module.exports = __webpack_public_path__ + "img/btn_gray_hover.737f3954.webp";